/* tslint:disable */
/* eslint-disable */
/* @relayHash f8222fe757d2f3c872d59841e8a5c290 */

import { ConcreteRequest } from "relay-runtime";
export type MultiUser_fetch2_QueryVariables = {};
export type MultiUser_fetch2_QueryResponse = {
    readonly manager: {
        readonly firstName: string;
        readonly lastName: string;
        readonly company: {
            readonly isContract: boolean;
        };
    } | null;
    readonly categories: {
        readonly edges: ReadonlyArray<{
            readonly name: string;
            readonly uuid: string | null;
            readonly classroomOnly: boolean;
            readonly secondaryCategories: ReadonlyArray<{
                readonly uuid: string | null;
                readonly name: string;
            } | null> | null;
        } | null> | null;
    } | null;
};
export type MultiUser_fetch2_Query = {
    readonly response: MultiUser_fetch2_QueryResponse;
    readonly variables: MultiUser_fetch2_QueryVariables;
};



/*
query MultiUser_fetch2_Query {
  manager {
    firstName
    lastName
    company {
      isContract
    }
  }
  categories {
    edges {
      name
      uuid
      classroomOnly
      secondaryCategories {
        uuid
        name
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "manager",
            "storageKey": null,
            "args": null,
            "concreteType": "Manager",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "company",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Company",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isContract",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryPage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Category",
                    "plural": true,
                    "selections": [
                        (v0 /*: any*/),
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "classroomOnly",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "secondaryCategories",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SecondaryCategory",
                            "plural": true,
                            "selections": [
                                (v1 /*: any*/),
                                (v0 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "MultiUser_fetch2_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": (v2 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "MultiUser_fetch2_Query",
            "argumentDefinitions": [],
            "selections": (v2 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "MultiUser_fetch2_Query",
            "id": null,
            "text": "query MultiUser_fetch2_Query {\n  manager {\n    firstName\n    lastName\n    company {\n      isContract\n    }\n  }\n  categories {\n    edges {\n      name\n      uuid\n      classroomOnly\n      secondaryCategories {\n        uuid\n        name\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'dc5a08cf3ff779029a7aa79fabfc9ab7';
export default node;
